import { render, staticRenderFns } from "./GoSamCartView.vue?vue&type=template&id=c28d66c0&"
import script from "./GoSamCartView.vue?vue&type=script&lang=ts&"
export * from "./GoSamCartView.vue?vue&type=script&lang=ts&"
import style0 from "./GoSamCartView.vue?vue&type=style&index=0&id=c28d66c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports